import { createClient } from '@supabase/supabase-js'
import { config } from './config'
import type { Database } from './database.types'

export const supabase = createClient<Database>(
  config.supabase.url,
  config.supabase.anonKey,
  {
    global: {
      fetch: (url, options) =>
        fetch(url, { ...options, signal: AbortSignal.timeout(4_000) }),
    },
    auth: {
      debug: false,
    },
  },
)

export async function healthCheck() {
  const { error } = await supabase.rpc('health_check')
  return !error
}

export interface SupabaseApiCount {
  timestamp: string
  total_auth_requests: number
  total_realtime_requests: number
  total_rest_requests: number
  total_storage_requests: number
}

export interface SupabaseRequestCount {
  timestamp: string
  count: number
}
